import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.RefundConfigTemplate.Save.IRequest;
type Response = Api.Core.RefundConfigTemplate.Save.IResponse;
type Headers = Api.Core.RefundConfigTemplate.Save.IHeaders;
const url = '/api/ProductManagement/RefundConfigTemplate';
export default async function refundConfigTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
